// @flow
import React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import theme from 'styled-theming'

import { myTheme } from '../styles'

const { color, space } = myTheme

const Space = styled.hr`
  border: none;
  margin-bottom: ${space.three};
`

const Container = styled.div`
  margin-bottom: ${space.one};
`

const PostTitle = styled.h1`
  margin-bottom: ${space.one};
`

const postDateColor = theme('mode', {
  dark: color.darkSilver,
  light: color.darkSilver,
})
const PostDate = styled.p`
  margin-top: 0;
  font-weight: 500;
  color: ${postDateColor};
`

const blockquote = {
  color: theme('mode', {
    dark: color.offWhite,
    light: color.lightBlueGray,
  }),
  borderColor: theme('mode', {
    dark: color.offWhite,
    light: color.silver,
  }),
}
const MarkdownContent = styled.article`
  line-height: 1.4;
  margin-bottom: ${space.three};

  p {
    font-size: 1rem;
    margin-bottom: 1rem;
    letter-spacing: 0.25pt;
  }

  blockquote {
    border-left: 0.25rem solid ${blockquote.borderColor};
    padding-left: 1rem;
    margin-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    font-style: italic;
    color: ${blockquote.color};
    > p {
      font-size: 1rem;
    }
  }
`

type Props = {
  data: {
    markdownRemark: {
      html: string,
      frontmatter: {
        date: string,
        path: string,
        title: string,
        description: string,
        keywords: Array<string>,
      },
    },
  },
}

const BlogTemplate = ({ data }: Props) => {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  return (
    <Container>
      <Helmet
        title={frontmatter.title}
        meta={[
          { name: 'description', content: frontmatter.description },
          { name: 'keywords', content: frontmatter.keywords },
        ]}
      />
      <div className="blog-post">
        <PostTitle>{frontmatter.title}</PostTitle>
        <PostDate>{frontmatter.date}</PostDate>
        <Space />
        <MarkdownContent
          className="serif"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </Container>
  )
}

export default BlogTemplate

// $FlowFixMe
export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM YYYY")
        path
        title
        description
        keywords
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-template.js